<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-type-none element-with-heading" id="historical-note">
<div class="heading heading-with-title heading-without-image" id="historical-note-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Historical Note</h1>
</div>
</div>
</div>
</div>
<div class="text" id="historical-note-text">
<p class="first first-in-chapter first-full-width"><span class="first-phrase"><span class="drop-cap">T</span>he history</span> that happened not so very long ago is often the least cherished – although, fortunately, relatively easy to research. In the writing of this book I have called on contemporary inquest reports, newspaper articles, and medical journals; the memoirs of celebrated London coroners, and some excellent online resources. The most vibrant and inspiring material has always come from written accounts, and oral history collections: I have done my very best to honour the memories they left for <span class="last-word">us</span>.</p>
<p class="subsq">I have deliberately brought forward two events into 1920 that, in reality, didn’t occur until later: the introduction into the UK of the stage act set to be the finale of the show, and the documented exploits of Brilliant Chang. Any other distortions of the truth are genuine <span class="last-word">mistakes</span>.</p>
<p class="subsq">If you’d like to follow some of the same research paths you can find route maps on my website www.bkduncan.com. But if you want to immerse yourself in what it might have been like to have lived and worked on those streets then visit the Museum of London Docklands; I would move in there if I <span class="last-word">could</span>.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// historical-note.vue?1cff3472